import React, { useCallback, useEffect, useMemo } from 'react';
import {
  CheckHashPopup,
  FairnessPopup,
  gameConfigStore,
  isMobile,
  popupStore,
  PopupTypes,
  PopupWr,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import {
  AboutHashInnerContent,
  AutoBetPopupTabContent,
  GameSpecificCheckHashPopupTopSection,
  HelpPopupContent,
} from './gameSpecificPopupContents';
import { globalTranslationKeys } from '../../../enums';

export const PopupsWrapper = observer(() => {
  const t = useTranslation();
  const { limits, gameConfiguration = {} } = gameConfigStore;
  const { autobet: isAutoBetConfigEnabled = false } = gameConfiguration;
  const { currencySymbolOrCode } = userInfoStore;
  const { close, popupToggle, isFromBetHistory, currentData } = popupStore;
  const ref = useRef();

  const popupLeftTabs = [
    {
      title: t(globalTranslationKeys.About),
      uniqueId: 1,
      isDefault: true,
    },
    ...(isAutoBetConfigEnabled
      ? [
          {
            title: t(globalTranslationKeys.AutoBet),
            uniqueId: 2,
          },
        ]
      : []),
    { title: t(globalTranslationKeys.FairnessModalTitle), uniqueId: 3 },
  ];
  const popupRightContents = useMemo(
    () => ({
      1: {
        component: <HelpPopupContent t={t} currencyCode={currencySymbolOrCode} limits={limits} />,
        popupRestProps: {
          from: 'from-left',
          size: 'is-small',
        },
      },
      2: {
        component: <AutoBetPopupTabContent t={t} />,
        popupRestProps: {
          from: 'from-left',
          size: 'is-small',
        },
      },
      3: {
        component: <FairnessPopup aboutHashInnerContent={<AboutHashInnerContent t={t} />} />,
        popupRestProps: {
          from: 'from-left',
          size: 'is-small',
        },
      },
      [PopupTypes.CheckHash]: {
        component: (
          <CheckHashPopup
            gameSpecificTopSection={
              <GameSpecificCheckHashPopupTopSection
                t={t}
                currentData={currentData}
                isFromBetHistory={isFromBetHistory}
              />
            }
            aboutHashInnerContent={<AboutHashInnerContent t={t} />}
          />
        ),
        popupRestProps: {
          from: `from-${isFromBetHistory ? 'right' : 'left'}`,
          size: 'is-small',
          withoutTabSection: true,
        },
      },
    }),
    [t, currentData, isFromBetHistory, limits]
  );

  const closePopup = useCallback(
    (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        close();
      }
    },
    [close]
  );

  useEffect(() => {
    if (!isMobile()) {
      document.body.addEventListener('click', closePopup, true);
    }

    return () => {
      document.body.removeEventListener('click', closePopup);
    };
  }, []);

  return popupToggle ? (
    <PopupWr
      // hasReplay
      popupLeftTabs={popupLeftTabs}
      popupRightWithSpecificData={popupRightContents}
      title={
        currentData
          ? `${t(globalTranslationKeys.RoundId)}: ${currentData?.roundId}`
          : t(globalTranslationKeys.Info)
      }
      isShowCloseIcon={!isMobile()}
      popupRef={ref}
    />
  ) : (
    <></>
  );
});
